
import img1 from "../assets/img-4.png"
import img2 from "../assets/quran.png"
import img3 from "../assets/img-3.png"

const serviceData=[
    {
        "id" : 1,
        "alt":"img1",
        "img": img1,
        "title": "خبرة طويلة في المناهج السعودية اهلي حكومي إنترناشيونال"
    },
    {
        "id" : 2,
        "alt":"img2",
        "img": img2,
        "title": "نوفر محفظات مجازات بأجر رمزى"
    },
    {
        "id" : 3,
        "alt":"img3",
        "img": img3,
        "title": "معلمين و معلمات متخصصين حضوري و اونلاين فى جميع المواد الدراسية"
    }

]

export default serviceData;